/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaDateRange/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import DateRangePicker from './DateRangePicker/react'
import RangeSelect from './RangeSelect/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaDateRange({
  children,
  viewPath = "/DesignSystem/TysiaInputDateRange/TysiaDateRange",
  innerRef,
  rangeTemplates,
  value,
  onChange,
  disableFuture,
  disablePast,
  datePast,
  dateFuture,
  yearPicker,
  yearPastFrom,
  yearTo,
  closePopover,
  onSave
  
}) {
let dtTysiainputdatepickerBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputDatePicker.backgroundColor.primary.base'
        })
let dtTysiainputdatepickerBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputDatePicker.borderColor.primary.base'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaDateRange.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1Ipv7N': dtTysiainputdatepickerBackgroundcolorPrimaryBase,'--bc-2-1Ipv7N': dtTysiainputdatepickerBordercolorPrimaryBase}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="TysiaDateRange.Horizontal"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--pt-3-1Ipv7N': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-1Ipv7N': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-5-1Ipv7N': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-6-1Ipv7N': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TysiaDateRange.List"
  data-view-path={viewPath}
 style={{'--g-7-1Ipv7N': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-8-1Ipv7N': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mr-9-1Ipv7N': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(rangeTemplates) && rangeTemplates.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="range"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/RangeSelect(${item?.id ?? item?._id ?? index})`}
      >
<RangeSelect
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/RangeSelect(${item?.id ?? item?._id ?? index})`}
 currentValue={value}
 onChange={onChange}
/>
</ListItem>
)}
</div>
<DateRangePicker
  viewPath={`${viewPath}/DateRangePicker`}
 onChange={onChange}
 value={value}
 disableFuture={disableFuture}
 disablePast={disablePast}
 datePast={datePast}
 dateFuture={dateFuture}
 yearPicker={yearPicker}
 yearPastFrom={yearPastFrom}
 yearTo={yearTo}
/>
</div>
<Actions
  viewPath={`${viewPath}/Actions`}
 closePopover={closePopover}
 onSave={onSave}
 currentValue={value}
/>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }